import { cn } from "@/lib/utils";
import React from "react";
import { GroupAvatar } from "./GroupAvatar";

type GroupDisplayNameProps = {
  group: {
    name: string;
  };
  className?: string;
  variant?: "default" | "large";
};

export const GroupDisplayName: React.FC<GroupDisplayNameProps> = ({
  group,
  className,
  variant = "default",
}) => {
  return (
    <div
      className={cn(
        "flex items-center gap-2",
        { "flex-col": variant === "large" },
        className,
      )}
    >
      <GroupAvatar
        size={variant === "large" ? "lg" : "sm"}
        className={className}
      />
      {group.name}
    </div>
  );
};

export const groupListLabel = (group: { name: string; personal: boolean }) =>
  group.personal ? "My workspace" : group.name;

type GroupOrUnknownDisplayNameProps = Pick<
  GroupDisplayNameProps,
  "className" | "variant"
> & {
  group: GroupDisplayNameProps["group"] | null;
};

export const GroupOrUnknownDisplayName: React.FC<
  GroupOrUnknownDisplayNameProps
> = ({ group, ...rest }) => {
  if (!group) {
    return <GroupDisplayName {...rest} group={{ name: "Unknown Group" }} />;
  }
  return <GroupDisplayName {...rest} group={group} />;
};
